import React from 'react';
import { Menu } from 'primereact/menu';

import GlobalTooltip from 'components/GlobalTooltip';
import { useMenuIconItems } from 'modules/FileManagerV2/hooks/ui/useMenuIconItems';

function MenuIcon({ item, index, itemsRef, onDownloadComplete }) {
  const { selectFile, getItemsOption, deletePermission } = useMenuIconItems({ onDownloadComplete });

  const viewItems = [{ label: 'Open', command: () => selectFile(item) }];

  return (
    <>
      <Menu
        model={deletePermission ? getItemsOption(item)?.filter((v) => v.show) : viewItems}
        popup
        id="popup_menu"
        ref={itemsRef[index]}
      />

      <span role="button" onClick={(event) => itemsRef[index]?.current?.toggle(event)}>
        <GlobalTooltip tooltip="More" position="top">
          <i className="icon-more d-inline-block rotate-90 text-primary-main" aria-hidden="true" aria-controls="popup_menu" aria-haspopup />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default MenuIcon;
